<template>
  <div class="spl-parcel-detail-header-holder">
    <div :class="{ 'spl-parcel-detail-header__return': !content.is_forward }" class="spl-parcel-detail-header">
      <div v-if="$mq !== 'sm'" class="row">
        <div class="col1 sm-col3">
          <a @click="goBack"><div class="spl-parcel-detail-header__back-arrow" /></a>
        </div>
        <div class="col2">
          <div class="spl-parcel-detail-header__label">
            Counter Number
          </div>
          <div class="spl-parcel-detail-header__value spl-parcel-detail-header__counter-number">
            {{ content.counter_number }}
          </div>
        </div>
        <div class="col2">
          <div class="spl-parcel-detail-header__label">
            Current Event
          </div>
          <div class="spl-parcel-detail-header__value spl-parcel-detail-header__current-event">
            {{ content.current_event }}
          </div>
        </div>
        <div class="col2">
          <div class="spl-parcel-detail-header__label">
            Timestamp
          </div>
          <div class="spl-parcel-detail-header__value spl-parcel-detail-header__current-event-timestamp">
            {{ content.current_event_timestamp }}
          </div>
        </div>
        <div v-if="content.signed_by_name !== ''" class="col2">
          <div class="spl-parcel-detail-header__label">
            Signed By
          </div>
          <div class="spl-parcel-detail-header__value  spl-parcel-detail-header__signed-by">
            {{ content.signed_by_name }}
          </div>
        </div>
        <div class="col1 spl-parcel-detail-header__direction">
          <div class="spl-parcel-detail-header__label">
            Direction
          </div>
          <div v-if="content.is_forward" class="spl-parcel-detail-header__value">
            Forward
          </div>
          <div v-if="!content.is_forward" class="spl-parcel-detail-header__value_return">
            Return
          </div>
        </div>
        <div v-if="content.direction_switch_parcel_id > 0" class="col2">
          <form-button
            v-if="content.is_forward"
            wide="true"
            @onClick="switchParcel">
            Show Return
          </form-button>
          <form-button
            v-if="!content.is_forward"
            wide="true"
            @onClick="switchParcel">
            Show Forward
          </form-button>
        </div>
        <div v-else-if="content.is_forward && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_RETURN)" class="col2">
          <form-button
            wide="true"
            @onClick="bookReturn">
            Book Return
          </form-button>
        </div>
      </div>
      <div v-else class="spl-parcel-detail-header__mobile">
        <div>
          <a @click="goBack"><div class="spl-parcel-detail-header__back-arrow" /></a>
        </div>
        <div class="spl-parcel-detail-header__mobile__event">
          <div class="spl-parcel-detail-header__label">
            Current Event
          </div>
          <div class="spl-parcel-detail-header__value spl-parcel-detail-header__current-event">
            {{ content.current_event }}
          </div>
        </div>
        <div v-if="content.direction_switch_parcel_id > 0" class="spl-parcel-detail-header__mobile__button">
          <form-button
            v-if="content.is_forward"
            wide="true"
            @onClick="switchParcel">
            Show Return
          </form-button>
          <form-button
            v-if="!content.is_forward"
            wide="true"
            @onClick="switchParcel">
            Show Forward
          </form-button>
        </div>
        <div
          v-else-if="content.is_forward && userHasPermission(constants.PERMISSION_TYPES.PARCEL, constants.PERMISSION_VALUES.BOOK_RETURN)"
          class="spl-parcel-detail-header__mobile__button">
          <form-button
            wide="true"
            @onClick="bookReturn">
            Book Return
          </form-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from '@/constants'
export default {
  name: 'ParcelDetailHeader',
  props: ['content'],
  data () {
    return {
      constants
    }
  },
  methods: {
    goBack () {
      this.$emit('detailClosed')
    },
    switchParcel () {
      this.$router.push('/parcel-detail/' + this.content.direction_switch_parcel_id)
      this.$router.go()
    },
    bookReturn () {
      this.$router.push('/parcel-book/' + this.content.counter_number)
    }
  }
}
</script>

<style lang="scss">
    @import '../../variables.scss';
.spl-parcel-detail-header-holder {
  height: 70px;
  width: 100%;

  .spl-parcel-detail-header {
    background-color: $yellowButtonLabelHover;
    height: 70px;
    padding: 17px $mainPadding 0 $mainPadding;
    width: 100%;
    position: fixed;
    z-index: 1100;
    margin-bottom: 60px;

    @include mobile() {
        padding: 17px $mobilePadding 0 $mobilePadding;
    }
    &__back-arrow {
        background-color: $middleYellow;
        background-image: url(../../assets/icon-back-arrow.svg);
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 50%;
        cursor: pointer;
        height: 40px;
        width: 40px;
    }
    &__label {
        color: $headerLatestUpdatesUpdateTitleColor;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        line-height: 12px;
        letter-spacing: 1px;
        margin: 0 20px 5px 0;
        text-transform: uppercase;
    }
    &__value {
        color: $headerLatestUpdatesDateColor;
        font-size: 16px;
        font-weight: 600;
    }
    &__value_return {
        color: $red;
        font-size: 16px;
        font-weight: 600;
    }
    &__return{
      border-bottom: 2px solid $red;
    }
  }
}

@include mobile () {
  .spl-parcel-detail-header-holder {
    height: auto;
    position: inline;

    .spl-parcel-detail-header {
      height: auto;
      position: initial;
      margin-bottom: 0px;
      &__mobile {
        display: flex;
        flex-wrap: wrap;
        &__event {
          width: calc(100% - 56px);
          margin: 3px 0 24px 10px;
          overflow: hidden;
        }
        &__button {
          flex-wrap: wrap;
          width: calc(100% - 10px);
          margin: 5px;
        }
      }
    }
  }
}
</style>
